import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert as ChakraAlert } from "@chakra-ui/react";
import * as React from "react";
export const FormErrorAlert = React.forwardRef(function FormErrorAlert(props, ref) {
    const { message, title = "Error", show = true, children, ...rest } = props;
    if (!show || (!message && !children)) {
        return null;
    }
    return (_jsxs(ChakraAlert.Root, { ref: ref, status: "error", w: "full", ...rest, children: [_jsx(ChakraAlert.Indicator, {}), children ? (_jsxs(ChakraAlert.Content, { children: [_jsx(ChakraAlert.Title, { children: title }), _jsx(ChakraAlert.Description, { children: children })] })) : (_jsx(ChakraAlert.Title, { flex: "1", children: message }))] }));
});
